import type { ModalProps } from 'antd';

import type {
	ProductionQuestionResolutionCategory,
	ProductionQuestionResolutionSource,
	ProductionQuestionStatus,
} from '../../../interfaces/ProductionQuestion.interface';

/** Centered modal with a fixed header/footer and scrollable body. */
export const SCROLLABLE_MODAL_STYLES: ModalProps['styles'] = {
	content: {
		display: 'flex',
		flexDirection: 'column',
		maxHeight: 'calc(100vh - 48px)',
	},
	header: {
		flexShrink: 0,
	},
	body: {
		flex: '1 1 auto',
		minHeight: 0,
		overflowX: 'hidden',
		overflowY: 'auto',
	},
	footer: {
		flexShrink: 0,
		paddingTop: 16,
		borderTop: '1px solid rgba(5, 5, 5, 0.06)',
	},
};

export const STATUS_COLORS: Record<ProductionQuestionStatus, string> = {
	not_reported: 'default',
	awaiting_response: 'orange',
	resolved: 'green',
};

export const RESOLUTION_SOURCE_OPTIONS: {
	label: string;
	value: ProductionQuestionResolutionSource;
}[] = [
	{ label: 'Internal', value: 'internal' },
	{ label: 'Answered by the Customer', value: 'customer' },
];

export const RESOLUTION_CATEGORY_OPTIONS: {
	label: string;
	value: ProductionQuestionResolutionCategory;
}[] = [
	{ label: 'Manufacture to 3D Model', value: 'manufacture_to_3d_model' },
	{ label: 'Manufacture to Drawing', value: 'manufacture_to_drawing' },
	{ label: 'New Order Created', value: 'new_order_created' },
	{ label: 'Other', value: 'other' },
];

export const STATUS_OPTIONS: {
	label: string;
	value: ProductionQuestionStatus;
}[] = [
	{ label: 'Not Reported to Customer', value: 'not_reported' },
	{ label: 'Awaiting Response from Customer', value: 'awaiting_response' },
	{ label: 'Resolved', value: 'resolved' },
];

export const getQuestionContextLineItemId = (
	question: { order_line_item_id?: string | null; order_line_items?: { id: string }[] },
	fallbackLineItemId?: string
): string | undefined =>
	fallbackLineItemId ??
	question.order_line_item_id ??
	question.order_line_items?.[0]?.id ??
	undefined;
